<template>
  <div class="google-signup-custom">
    <div v-if="initialized" class="signup-button" @click="click">
      {{ label }}
    </div>
    <component :is="{ template: error }" v-if="error" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { amplitudeTrack } from "@/utils/amplitude";
import googleSignup from "@/utils/googleSignup";

defineOptions({
  name: "google-signup-custom",
});

defineProps({
  label: {
    type: String,
    default: "",
  },
});

const route = useRoute();
const { t } = useI18n();

const initialized = ref(false);
const error = ref<string | null>(null);

const click = () => {
  googleSignup.openPopup();
};

onMounted(() => {
  googleSignup.on("error", (e: any) => {
    const status = e.status?.status;

    if (status === 401) {
      if (route.meta.landing_id) {
        error.value = t("Email is already taken. [login]").replace("[login]", `<router-link to="/#log_in">${t("Login?")}</router-link>`);
      } else {
        error.value = t("Something went wrong. Please try to log in with your username and password.");
      }
    } else {
      error.value = t("Something went wrong.");
    }

    error.value = `<p class="error">${error.value}</p>`;
  });

  googleSignup.on("ready", () => {
    initialized.value = true;
    amplitudeTrack("Google button displayed");
  });

  googleSignup.init();
});

onBeforeMount(() => {
  googleSignup.off();
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
